<svg width="140" height="90" viewBox="0 0 140 90" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="139" height="88.7739" rx="3.5" fill="currentColor" stroke="#BBBFC3"/>
    <rect x="43" y="4" width="55" height="39" rx="2.51724" fill="#BBBFC3"/>
    <rect x="119" y="45" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="99" y="45" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="80" y="45" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="62" y="45" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="43" y="45" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="24" y="45" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="5" y="45" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="119" y="18" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="99" y="18" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="24" y="18" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="5" y="18" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="119" y="4" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="99" y="4" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="24" y="4" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="5" y="4" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="119" y="59" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="99" y="59" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="80" y="59" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="62" y="59" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="43" y="59" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="24" y="59" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="5" y="59" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="119" y="32" width="17" height="11" rx="2" fill="#BBBFC3"/>
    <rect x="99" y="32" width="18" height="11" rx="2" fill="#BBBFC3"/>
    <rect x="24" y="32" width="18" height="11" rx="2" fill="#BBBFC3"/>
    <rect x="5" y="32" width="17" height="11" rx="2" fill="#BBBFC3"/>
    <rect x="119" y="73" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="99" y="73" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="80" y="73" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="62" y="73" width="17" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="43" y="73" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="24" y="73" width="18" height="12" rx="2" fill="#BBBFC3"/>
    <rect x="5" y="73" width="17" height="12" rx="2" fill="#BBBFC3"/>
</svg>
